import React from "react"
import Search from "./Search"
import Typography from "aldoo-ra/Typography"
import CMSRender from "aldoo-ra/CMS/cms-render"

/**
 * Header component for the Help Center
 * @param {Object} props
 * @param {Object} props.searchState - Search state from useSearch hook
 * @param {Function} props.onSearchResultSelect - Handler for search result selection
 */
const Header = ({ searchState, onSearchResultSelect }) => {
  
  return (
    <CMSRender
      contentType="HCHomeHeader"
      renderItem={(data) => {
        return (
          <div className="header-container w-full">
            <div className="relative w-full max-w-w2_xl md:h-[290px] rounded-[50px] mt-6 md:mt-12 mx-auto">
              <div className="relative w-ful h-full flex flex-col items-center justify-center z-20 mx-auto">
                <Typography 
                  className="text-4xl font-bold text-text text-center mb-8"
                  variant="h1"
                >
                  {data.title}
                </Typography>

                <Search
                  searchState={searchState}
                  onResultSelect={onSearchResultSelect}
                />
              </div>

              {/* Backgrounds */}
              <div className="hidden md:block absolute top-0 left-0 w-full h-full rounded-[50px] overflow-hidden">
                <img 
                  src={data.background_shape_left} 
                  alt="Header Background"
                  className="absolute top-0 -left-[200px] lg:left-0 w-auto h-full object-cover z-10"
                />

                <img 
                  src={data.background_shape_right} 
                  alt="Header Background"
                  className="absolute top-0 -right-[160px] lg:right-0 w-auto h-full object-cover z-10"
                />

                <img 
                  src={data.background_gradient} 
                  alt="Header Background"
                  className="absolute top-0 left-0 w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default Header
